import { useEffect, useState } from 'react';

import {
  AppConfig,
  CollectionRestaurantSummary,
  DeliveryRestaurantSummary,
} from '../weborder/Api';
import * as Data from '../weborder/Data';

interface UseRestaurantSummaries {
  collectionData: CollectionRestaurantSummary[] | null;
  deliveryData: DeliveryRestaurantSummary[] | null;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useRestaurantSummaries = (
  appConfig: Data.Async<AppConfig>,
  collectionSummaries: Data.Async<CollectionRestaurantSummary[]>,
  deliverySummaries: Data.Async<DeliveryRestaurantSummary[]>,
  getRestaurantSummaries: () => void,
): UseRestaurantSummaries => {
  const [isLoading, setIsLoading] = useState<boolean>(
    collectionSummaries.status !== 'success' ||
      deliverySummaries.status !== 'success',
  );
  const [isSuccess, setIsSuccess] = useState<boolean>(
    collectionSummaries.status === 'success' &&
      deliverySummaries.status === 'success',
  );

  useEffect(() => {
    if (!isSuccess) {
      // * Redux state - flipdish.CollectionSummaries && flipdish.DeliverySummaries
      // - set restaurant collection/delivery summaries
      getRestaurantSummaries();
    }
  }, []);

  useEffect(() => {
    if (appConfig.status === 'success') {
      const isCollectionLoaded =
        collectionSummaries.status === 'success' ||
        !appConfig.data.PickupEnabled;
      const isDeliveryLoaded =
        deliverySummaries.status === 'success' ||
        !appConfig.data.DeliveryEnabled;

      if (isCollectionLoaded && isDeliveryLoaded) {
        setIsLoading(false);
        setIsSuccess(true);
      }
    }
  }, [appConfig.status, collectionSummaries.status, deliverySummaries.status]);

  const collectionData =
    collectionSummaries.status === 'success' ? collectionSummaries.data : null;
  const deliveryData =
    deliverySummaries.status === 'success' ? deliverySummaries.data : null;

  return {
    collectionData,
    deliveryData,
    isLoading,
    isSuccess,
  };
};
